var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: 998.41,
    y1: -445.122,
    x2: 1012.727,
    y2: -445.122,
    gradientTransform: "rotate(-17.54 2097.97 2876.663)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: 3895.098,
    y1: -165.344,
    x2: 3912.879,
    y2: -165.344,
    gradientTransform: "scale(-1 1) rotate(5.475 21.47 -41532.753)",
    xlinkHref: "#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: -355.105,
    y1: 368.505,
    x2: -322.134,
    y2: 368.505,
    gradientTransform: "rotate(8.592 2146.865 2846.707)",
    xlinkHref: "#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: 10.125,
    y1: 35.091,
    x2: 30.485,
    y2: 35.091,
    xlinkHref: "#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: 12.335,
    y1: 35.08,
    x2: 28.192,
    y2: 35.08,
    xlinkHref: "#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355",
    x1: 7.46,
    y1: 44.256,
    x2: 33.085,
    y2: 44.256,
    xlinkHref: "#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M30.169 37.152h5.411M5.048 37.152h5.399M38.766 9.276v47.448M41.863 37.355s2.38 3.5 5.46 0c0 0 2.47 3.77 5.59-.13M57.462 37.355s2.38 3.5 5.46 0c0 0 2.47 3.77 5.59-.13 0 0 2.47 3.9 5.785-.065 0 0 2.622 3.532 5.655.065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M56.428 22.908s-1.461 2.28-2.79 10.153-.805 19.444-.805 19.444.926 1.046 2.355 1.103c1.885.084 3.185-1.346 3.185-1.346s-2.6-7.15-.13-25.999",
    stroke: "url(#SVGID_0_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M62.403 19.054s1.313-.605 3.001-2.072c1.688-1.468 3.195-4.137 3.195-4.137s-1.941.186-5.089 1.402c-3.148 1.216-4.795 3.333-4.795 3.333s-1.804-1.568-3.354-2.29-3.226-.953-3.226-.953 1.058 3.316 2.963 4.57",
    stroke: "url(#SVGID_1_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M57.136 19.141s-3.877-.54-8.817 2.571c-3.975 2.818-4.94 3.9-4.94 3.9s3.181 1.31 8.493-.78 5.758-3.162 5.758-3.162-.146 2.399.62 4.819c1.89 5.27 4.173 5.296 4.173 5.296s.907-3.587-1.618-9.373c0 0 1.025 1.543 6.927 2.917 6.227 1.007 7.8-.195 7.8-.195s-2.08-3.51-7.8-5.07c-4.807-1.252-6.847-.796-6.847-.796",
    stroke: "url(#SVGID_2_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_3_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)",
    d: "M10.75 28.071h19.11v14.04H10.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_4_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)",
    d: "M12.96 30.411h14.607v9.338H12.96z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_5_e91876717ba075ac28cdb2043f4a1cd5a1263ff2db18b03c97e20cb1e9046355)",
    d: "M10.859 42.067l-2.774 4.507H32.46l-2.665-4.637"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.44d0e8b143a0149ea1593bc47854c47b.svg";
export { ForwardRef as ReactComponent };